import { render, staticRenderFns } from "./ChannelsMMS.vue?vue&type=template&id=97712dac"
import script from "./ChannelsMMS.vue?vue&type=script&lang=js"
export * from "./ChannelsMMS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports